module.exports = __webpack_public_path__ + "img/download_settings.30a60260.png";